import dayjs from 'dayjs';

const PRICE_DELIMITER = '.';
const NUMBER_DELIMITER = ' ';
const TIME_FORMAT = 'DD MMM';

export const CURRENCY = 'EUR';
export const POINT_WARNING_PERCENTAGE = 0.25;
export const TRAFFIC_PARAMS = [
  'iot_traffic_in',
  'iot_traffic_out',
  'traffic_in',
  'traffic_out',
  'stream_traffic',
  'request',
];
export const STORAGE_PARAMS = ['document', 'log_row', 'file'];

export const COLORS = {
  traffic: '#f29e00',
  iot_traffic_in: '#e8af8c',
  iot_traffic_out: '#feb528',
  traffic_in: '#2e09a4',
  traffic_out: '#775dd0',
  request: '#A27C7E',
  stream_traffic: '#1ae59e',
  storage: '#575A4B',
  document: '#94C5CC',
  file: '#A8994D',
  log_row: '#7D80DA',
  point: '#0094f9',
  point_warning: 'orange',
  point_alert: 'red',
  total: '#052F5F',
  manufactured_and_owned: '#005377',
  manufactured_not_owned: '#06A77D',
  owned_not_manufactured: '#0A60C2',
  shared_networks: '#F1A208',
  limit: 'red',
};

export function formatPoints(points) {
  return points?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, NUMBER_DELIMITER);
}

export function roundPoints(points) {
  if (points >= 1000000) {
    return `${Math.round(points / 1000000)}M`;
  }
  if (points >= 1000) {
    return `${Math.round(points / 1000)}K`;
  }
  return Math.round(points);
}

export function formatPrice(price) {
  const formattedPrice = Number(price).toFixed(2);
  const split = String(formattedPrice).split('.');
  return split[0] + PRICE_DELIMITER + split[1];
}

export function totalTraffic(item, total) {
  if (!item) {
    return 0;
  }
  let traffic = 0;
  traffic = item.iot_traffic_in + item.iot_traffic_out;
  if (total) {
    traffic = traffic + item.traffic_in + item.traffic_out + item.stream_traffic + item.request;
  }
  return traffic;
}

export function totalStorage(item) {
  if (!item) {
    return 0;
  }
  const storage = item.document + item.log_row + item.file;

  return storage;
}

export function logTimeFormat(timestamp) {
  if (typeof timestamp !== 'function') {
    return dayjs(timestamp).format(TIME_FORMAT);
  }
  return timestamp.format(TIME_FORMAT);
}
